import type { NodeProps } from '../types';

/**
 * Compass injects WPContentPageHeader into calculator flex/main content.
 * ria-client renders title/byline/synopsis from page metadata instead, so this is a no-op
 * (mirrors `@ria-client/ui` StructuredContentRenderer).
 */
export type WPContentPageHeaderProps = NodeProps<{
  id?: number | string;
  hideAuthorByline?: boolean;
  hideFeaturedImage?: boolean;
  templateOverride?: unknown;
}>;

export function WPContentPageHeader(_props: WPContentPageHeaderProps): null {
  return null;
}
